import axios from 'axios'
const config = require('../../config.json');

var baseUrl = config.clarityPayMiddlewareUrl;

export async function loginRequest(endpoint, apiReqType, auth) {
	let apiResponse;

	let requestConfig = {
		method: apiReqType,
		maxBodyLength: Infinity,
		url: baseUrl + endpoint,
		headers: {
			'Authorization': auth,
			'Content-Type': config.verifyUser.contentType
		}
	};

	await axios.request(requestConfig)
		.then((response) => {
			apiResponse = response;
		})
		.catch((error) => {
			console.log(error);
		});

	return apiResponse;
}

export function request(endpoint, data, apiReqType) {
	let apiResponse;
	let sessionToken = null;
	let encCred = null;

	if (localStorage.getItem('login'))
		encCred = localStorage.getItem('login');

	if (localStorage.getItem('token'))
		sessionToken = localStorage.getItem('token');

	let requestConfig = {
		headers: {
			'authorization': config.authorization,
			'Content-Type': config.contentType,
			'Authorization': encCred,
			'merchant-token': sessionToken
		}
	};
	switch (apiReqType) {
		case 'get':
			apiResponse = axios.get(baseUrl + endpoint, requestConfig);
			break;
		case 'post':
			apiResponse = axios.post(baseUrl + endpoint, data, requestConfig);
			break;
		case 'put':
			apiResponse = axios.put(baseUrl + endpoint, data, requestConfig);
			break;
		case 'delete':
			apiResponse = axios.delete(baseUrl + endpoint, requestConfig);
			break;
	}

	return apiResponse;
}